

































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";
import { Watch, Prop } from "vue-property-decorator";

import Schedule from "@/types/app/schedules";

import moment from "moment";
import VuetifySelectItems from "@/types/app/vuetifySelectItems";
import Customer from "@/types/customer/Customer";
import Notification, {
    notificationInitialValue, WebAppEmail
} from "@/types/app/notifications";
import AccountInterface from "@/types/app/accounts";
import { SelectedCustomersInterface } from "@/types/selectedCustomersInterface";
const namespace = "customer";


@Component({})
export default class SelectedCustomers extends Vue implements SelectedCustomersInterface  {

    @Getter('getCustomersAll', { namespace: 'customer' }) customers!: Customer[];
    @Getter('getAccountsState', { namespace: 'account' }) accounts!: AccountInterface[];    
    @Prop(Notification) public emailNotification!: Notification;

    selectedNotificationCustomers: any[] = [];
    filteredCustomers: VuetifySelectItems[] = [];
    selectedCustomers: any[] = [];
    customersSelectItems: VuetifySelectItems[] = [];
    


    public async changeSelectedCustomers(loadingAll=true, loadingProduct=false, loadingFund = false, fundId='') : Promise<void> {
    
       if(this.customersSelectItems.length == 0){
        await this.loadCustomers();
       }
       if(loadingAll){
         this.filteredCustomers = this.customersSelectItems;
       }
       else this.filteredCustomers = this.customersSelectItems.filter(x => x.data.status == 1);

       if(loadingProduct)
         this.filteredCustomers = this.filteredCustomers.filter(x => x.data.canViewProduct);
       if(loadingFund && fundId)
            await this.canViewerFund(fundId);

    }

    async loadCustomers(){
       this.customersSelectItems = await this.getCustomers();
    }

     get likesAllCustomer() {
        return this.selectedCustomers.length === this.filteredCustomers.length;
    }

    get likesSomeCustomers() {
        return this.selectedCustomers.length > 0 && !this.likesAllCustomer;
    }

    toggleSelectAll() {
        this.$nextTick(() => {
            if (this.likesAllCustomer) {
                this.selectedCustomers = [];
            } else {
                this.selectedCustomers = this.filteredCustomers.map(x => x.value);
            }
        });

    }

    async canViewerFund(fundId='') {
        this.selectedCustomers = [];
        this.filteredCustomers = this.filteredCustomers.filter((item) =>
            this.accounts.some((x) => x.userId == item.value && fundId)
        );

    }


    get icon() {
        if (this.likesAllCustomer) return 'mdi-close-box';
        if (this.likesSomeCustomers) return 'mdi-minus-box';
        return 'mdi-checkbox-blank-outline';
    }

    async checkCustomerHasAccount(customer:Customer) {
        return this.accounts.some((x) => x.userId === customer.id) 
        ||   (customer.scheduleIndexResponse &&
                customer.scheduleIndexResponse.status === 'Done');
    }

     async getCustomers(): Promise<VuetifySelectItems[]> {
        const customerOrdened = this.customers.sort((a, b) =>
            a.fullName.localeCompare(b.fullName)
        );

        const itemsForVuetifySelect = await Promise.all(
            customerOrdened.map(async (item) => {
                return {
                    text: `${item.fullName} - ${item.email}`,
                    value: item.id,
                    data: {
                        ...item,
                        canViewProduct: await this.checkCustomerHasAccount(item)
                    },
                };
            })
        );
        return itemsForVuetifySelect;
    }


}
